module.exports = __webpack_public_path__ + "img/About_Employers_DARK-04.9cd29d6.svg";